import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { t } from "@workspace/strings/web";

export default function NotFound() {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center gap-6 bg-background px-4 text-center">
      <p className="text-7xl font-semibold tracking-tight text-primary">
        {t("webMisc.notFound.code")}
      </p>
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">
          {t("webMisc.notFound.title")}
        </h1>
        <p className="mx-auto max-w-sm text-sm text-muted-foreground">
          {t("webMisc.notFound.description")}
        </p>
      </div>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Button asChild>
          <Link href="/dashboard">{t("webMisc.notFound.goToDashboard")}</Link>
        </Button>
        <Button asChild variant="outline">
          <Link href="/">{t("webMisc.notFound.backHome")}</Link>
        </Button>
      </div>
    </div>
  );
}
